import { combineReducers } from 'redux';
import merge from 'lodash/merge';
import mergeWith from 'lodash/mergeWith';
import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';
import * as types from './types';

const dynamicItems = (state = {}, action) => {
  switch (action.type) {
    case types.SET_DYNAMIC_ITEMS:
      //force recreating a new object {...}
      return { ...merge(state, action.payload) };
    case types.REMOVE_DYNAMIC_ITEMS:
      return omitBy(
        mergeWith(state, action.payload, (objValue, srcValue) => ({
          ...objValue,
          ...srcValue,
        })),
        isEmpty,
      );
    default:
      return state;
  }
};

const questionProps = (state = {}, action) => {
  switch (action.type) {
    case types.SET_QUESTION_PROPS:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  dynamicItems,
  questionProps,
});
